import React from 'react';
import { LpStyleProfile } from '../../services/api/lpGenerationService';

interface StyleProfileCardProps {
  profile: LpStyleProfile | null;
}

const StyleProfileCard: React.FC<StyleProfileCardProps> = ({ profile }) => {
  if (!profile) return null;

  return (
    <div className="rounded-lg border border-warm-border bg-white p-4">
      <h3 className="mb-3 text-sm font-semibold text-gray-900">スタイル解析</h3>
      <div className="mb-3 flex gap-2">
        {Object.entries(profile.palette).map(([key, color]) => (
          <div key={key} className="flex items-center gap-1.5 text-xs text-gray-600">
            <span className="h-4 w-4 rounded border border-gray-200" style={{ backgroundColor: color }} />
            <span>{color}</span>
          </div>
        ))}
      </div>
      <dl className="grid gap-2 text-xs text-gray-700 sm:grid-cols-2">
        <div>
          <dt className="font-medium text-gray-500">フォント</dt>
          <dd>{profile.font_tone}</dd>
        </div>
        <div>
          <dt className="font-medium text-gray-500">構図</dt>
          <dd>{profile.composition}</dd>
        </div>
        <div className="sm:col-span-2">
          <dt className="font-medium text-gray-500">ムード</dt>
          <dd>{profile.mood.join(' / ')}</dd>
        </div>
      </dl>
    </div>
  );
};

export default StyleProfileCard;
